import React from 'react';
import type PermissionSchemePageType from '@atlassian/jira-permission-scheme/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyPermissionSchemePage = lazyForPaint<typeof PermissionSchemePageType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-permission-scheme", jiraSpaEntry: "async-jira-permission-scheme" */ '@atlassian/jira-permission-scheme'
		),
	),
);

const AsyncPermissionSchemePage = (): React.JSX.Element => (
	<LazyPage Page={LazyPermissionSchemePage} pageId="jira-permission-scheme" shouldShowSpinner />
);

export default AsyncPermissionSchemePage;
